import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import img from "@/assets/progettazione-balneare.jpg";
import { Sun, Building2, Home as HomeIcon } from "lucide-react";

const Progettazione = () => (
  <>
    <SEO
      title="Progettazione di ambienti accessibili — FIABA ETS"
      description="Servizio dedicato per cittadini, condomini e stabilimenti balneari. Progettiamo ambienti accessibili secondo i principi dell'Universal Design."
      path="/progettazione-accessibile"
    />
    <PageHero
      eyebrow="Ufficio Tecnico"
      title="Progettazione di ambienti accessibili"
      subtitle="Soluzioni pensate per rispondere alle esigenze di ogni persona, a partire dalla condizione individuale."
    />
    <section className="section-padding">
      <div className="container-narrow grid lg:grid-cols-2 gap-12 items-center">
        <img src={img} alt="Stabilimento balneare accessibile con rampa e terrazza in legno" className="rounded-lg shadow-elegant" loading="lazy" />
        <div className="space-y-5 leading-relaxed text-foreground/90">
          <p>FIABA, attraverso il proprio <strong>Ufficio Tecnico</strong>, ha avviato da diversi anni un servizio dedicato a tutti i cittadini che necessitano di informazioni e soluzioni per la progettazione di ambienti accessibili.</p>
          <p>Un'altra iniziativa di rilievo nazionale che rende FIABA una realtà di primissimo piano riguarda il <strong>settore balneare</strong>: da oltre due anni proponiamo modelli di accessibilità e inclusione per gli stabilimenti balneari, considerando ogni aspetto della condizione umana.</p>
        </div>
      </div>
      <div className="container-narrow mt-16 grid md:grid-cols-3 gap-5">
        {[
          { i: HomeIcon, t: "Per cittadini", d: "Consulenze e soluzioni per abitazioni private e condomini." },
          { i: Building2, t: "Per imprese", d: "Audit e progettazione di uffici, spazi commerciali e strutture ricettive." },
          { i: Sun, t: "Per stabilimenti balneari", d: "Modelli di accessibilità per la fruizione in autonomia, sicurezza e comfort." },
        ].map((s) => (
          <div key={s.t} className="bg-card p-6 rounded-lg shadow-soft border border-border">
            <s.i className="w-10 h-10 text-secondary mb-3" />
            <h3 className="font-serif font-bold text-primary text-lg mb-2">{s.t}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default Progettazione;
